export default "__VITE_ASSET__D10pn6$7__"